export default function Header() {
  return (
    <div className="fixed inset-0 w-full z-50 h-14 pt-3 bg-white border shadow">
      <div className="w-full md:w-11/12 md:my-0 md:mx-auto lg:w-9/12">
        <h2 className="text-2xl font-medium">FakeShop</h2>
      </div>
    </div>
  );
}
